import { AddsensitiveWordRequest, EditsensitiveWordRequest, getSensitiveWordRequest, getSensitiveWordResponse } from '../../types/sensitiveWord/Type';
import axios from '../axiosCall'
import Urls from "../endpoints";

export const getSensitiveWords = (params: getSensitiveWordRequest) => {
    return axios.post<getSensitiveWordResponse[]>(Urls.GetSensitiveWord(), params)
}

export const editSensitiveWord = (params: EditsensitiveWordRequest) => {
    return axios.put(Urls.EditSensitiveWord(), params)
}

export const addSensitiveWord = (params: AddsensitiveWordRequest) => {
    return axios.post(Urls.AddSensitiveWord(), params)
}
export const deleteSensitiveWord = (id: string) => {
    return axios.delete(Urls.DeleteSensitiveWord(id))
}
export const getSensitiveWordById = (id: string) => {
    return axios.get<getSensitiveWordResponse>(Urls.GetSensitiveWordById(id))
}




